module.exports = import("https://js.prosopo.io/js/procaptcha.bundle.js");;